import React, { useCallback, useEffect } from "react";
import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import BrandCreateForm from "../../components/brand/BrandCreateForm";
import { BrandPopulationProgress } from "../../components/brand/BrandPopulationProgress";
import { brandsApi } from "../../redux/api/brandsApi";
import { setCurrentBrand } from "../../redux/brand/brandSlice";
import { brandsService } from "../../services/brands";

const BrandNewPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentProject } = useSelector((state) => state.project);
  const { currentBrand } = useSelector((state) => state.brand);

  const handleBrandCreated = (brand) => {
    if (currentProject?.hash) {
      dispatch(
        brandsApi.util.invalidateTags([{ type: "Brands", id: "LIST" }]),
      );
    }
    if (brand?.hash) {
      dispatch(setCurrentBrand(brand));
      navigate(`/brand/new/populating/${brand.hash}/`);
    }
  };

  const handleCancel = () => {
    navigate(currentBrand?.hash ? "/brand/overview/" : "/");
  };

  return (
    <div className="max-w-2xl">
      <BrandCreateForm
        projectHash={currentProject?.hash}
        onCancel={handleCancel}
        onCreated={handleBrandCreated}
      />
    </div>
  );
};

const BrandNewPopulatingPage = ({ loadBrand }) => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hash) {
      navigate("/brand/new/", { replace: true });
    }
  }, [hash, navigate]);

  const refreshBrand = useCallback(() => {
    if (!hash) {
      return Promise.resolve();
    }
    return new Promise((resolve) => {
      brandsService.getBrand(
        hash,
        (response) => {
          if (response?.data) {
            dispatch(setCurrentBrand(response.data));
          }
          loadBrand?.();
          resolve();
        },
        () => {
          loadBrand?.();
          resolve();
        },
      );
    });
  }, [dispatch, hash, loadBrand]);

  if (!hash) {
    return null;
  }

  return (
    <BrandPopulationProgress
      brandHash={hash}
      brandUrl="/brand/overview/"
      onBeforeNavigateToBrand={refreshBrand}
    />
  );
};

const BrandNewRoutes = ({ loadBrand }) => (
  <Routes>
    <Route index element={<BrandNewPage />} />
    <Route
      path="populating/:hash/*"
      element={<BrandNewPopulatingPage loadBrand={loadBrand} />}
    />
  </Routes>
);

export default BrandNewRoutes;
